<template>
  <v-container
    class="black--text d-flex justify-center"
    id="cmp-title-container"
  >
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <v-card id="home-content-area" class="title-card background_color">
      <v-card-title
        elevation="2"
        tile
        class="d-flex title-card-text justify-center"
        style="line-height: 1.15"
        v-html="title_text"></v-card-title
      >
    </v-card>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #cmp-title-container {
    width: 100vw;
    margin: 0 auto;
  }
  .title-card {
    width: 100%;
  }

  .title-card-text {
    font-size: 2.5rem;
    font-weight: 400;
    word-break: keep-all;
    text-align: center;
  }
}
#home-content-area {
  width: 100%;
  max-width: 100%;
  height: 100%;
}

/* 768 media q */
@media (min-width: 768px) {
  .basic-interior-card {
    min-height: 200px;
  }
  #init-title-container {
    width: 100%;
    height: 80vh;
  }
  #cmp-title-container {
    width: 100vw;

    height: auto;
    position: relative;
    top: 0px;
  }
  #home-content-area {
    width: 100%;
    max-width: 85%;
    height: auto;
    background-color: white;
  }
  #all-panels {
    width: 95%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "titlecard",
  mixins: [bus_common],
  props: ["title_text"],
  data() {
    return {};
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
